<div [ngStyle]="{'width': width, 'justify-content':align}"></div>
<ng-content></ng-content>
